import PropTypes from "prop-types";

export default function HelpGuideFooterActions({
  onClose,
  primaryLabel = "Got it",
  secondaryLabel = "Close",
}) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <button
        type="button"
        onClick={onClose}
        className="rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:bg-slate-50"
      >
        {secondaryLabel}
      </button>
      <button
        type="button"
        onClick={onClose}
        className="rounded-full bg-rose-500 px-4 py-2 text-sm font-semibold text-white hover:bg-rose-600"
      >
        {primaryLabel}
      </button>
    </div>
  );
}

HelpGuideFooterActions.propTypes = {
  onClose: PropTypes.func.isRequired,
  primaryLabel: PropTypes.string,
  secondaryLabel: PropTypes.string,
};
